export const Users=[
    {
        id: 1,
        name: 'John Doe',
        email: 'john@gmail.com',
    },
    {
        id: 2,
        name: 'Akangkha Sarkar',
        email:"abc@gmail.com"
    }
    
]